
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { MyErrorStateMatcher } from '../../../shared/material.module';
import { DialogData, GlobalsService } from '../../../shared/shared';
import { GridOptions } from 'ag-grid-community';

@Component({
    selector: 'termin-list',
    templateUrl: 'termin-list.component.html',
    styleUrls: ['termin-list.component.css']
})
export class TerminListComponent implements OnInit {
    public matcher = new MyErrorStateMatcher();
    public gridOptions: GridOptions;
    public rowData: any[];
    private columnDefinitions: any[];

    constructor(public dialogRef: MatDialogRef<TerminListComponent>, private globalService: GlobalsService, @Inject(MAT_DIALOG_DATA) public dialog: DialogData) {
        this.createColumnDefinitions();
        this.initGrid();
        this.rowData = dialog.Params;
    }

    ngOnInit() {
       
    }

    initGrid() {
        this.gridOptions = Object.assign(this.globalService.GridOptions, {
            columnDefs: this.columnDefinitions,
            onGridSizeChanged: function (params) {
                params.api.sizeColumnsToFit();
            },
            onViewportChanged: function (params) {
                params.api.sizeColumnsToFit();
            },
        });
    }

    createColumnDefinitions() {
        this.columnDefinitions = [
            {
                headerName: "Id",
                field: "id",
                width: 1,
                hide: true,
                suppressMenu: true
            },
            {
                headerName: "Betreff",
                field: "Subject",
                width: 200,
                suppressMenu: true,
                resizable: true,
                sortable: true,
            },
            {
                headerName: "Terminstatus",
                field: "Terminstatus",
                width: 200,
                suppressMenu: true,
                resizable: true,
                sortable: true,
            },
            {
                headerName: "Datum",
                field: "StartDate",
                cellRenderer: function (params) {
                    if (params.value)
                        return params.value.split(' ')[0];

                    return '';
                },
                width: 200,
                suppressMenu: true,
                resizable: true,
                sortable: true,
            }
        ];
    }

    onCreate(event) {
        if (event === true)
            this.dialogRef.close(true);
    }

    onClose() {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/_vertrag/vertrag-list/termin-list/termin-list.component.ts